import {DomainCard, ExploreLayout, GroupsExplorerContent} from '@backstage-community/plugin-explore';
import {Grid} from '@material-ui/core';
import {catalogApiRef} from '@backstage/plugin-catalog-react';
import {useApi} from '@backstage/core-plugin-api';
import {useAsync} from 'react-use';
import {DomainEntity} from '@backstage/catalog-model';
import {DependencyGraphTypes} from '@backstage/core-components';
import {OverviewContent} from './OverviewContent';

const DomainTypeExplorerContent = ({type}: {type: string}) => {
    const catalogApi = useApi(catalogApiRef);

    const {value: entities, loading, error} = useAsync(async () => {
        const response = await catalogApi.getEntities({
            filter: {
                kind: 'Domain',
                'spec.type': type,
            },
        });
        return response.items as DomainEntity[];
    }, [catalogApi, type]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading domains: {error.message}</div>;
    }

    return (
        <Grid container spacing={3}>
            {entities?.map(entity => (
                <Grid item xs={12} sm={6} md={4} key={entity.metadata.name}>
                    <DomainCard entity={entity}/>
                </Grid>
            ))}
        </Grid>
    );
};

export const ExplorePage = () => {
    return (
        <ExploreLayout
            title="Explore the Douglas Group ecosystem"
            subtitle="Browse our ecosystem"
        >
            <ExploreLayout.Route path="overview" title="Overview">
                <OverviewContent/>
            </ExploreLayout.Route>
            <ExploreLayout.Route path="domains" title="Domains">
                <DomainTypeExplorerContent type="domain"/>
            </ExploreLayout.Route>
            <ExploreLayout.Route path="missions" title="Missions">
                <DomainTypeExplorerContent type="mission"/>
            </ExploreLayout.Route>
            <ExploreLayout.Route path="groups" title="Groups">
                <GroupsExplorerContent direction={DependencyGraphTypes.Direction.BOTTOM_TOP as any}/>
            </ExploreLayout.Route>
        </ExploreLayout>
    );
};

export const explorePage = <ExplorePage/>;
